module.exports = __webpack_public_path__ + "img/reference_values.fc4f9331.svg";